import React from 'react'
import { Grid, Row } from 'react-bootstrap'
import SettingsPersonal from '../containers/SettingsPersonal'
import SettingsStatus from '../containers/SettingsStatus'

export const RouteView = () => {
	return <Grid>
		<Row className='show-grid'>
			<SettingsPersonal />
			<SettingsStatus />
		</Row>
	</Grid>
}

export default RouteView



// WEBPACK FOOTER //
// ./src/routes/Settings/components/RouteView.js